import React from 'react';
import workex from '../Data/workex';
import WorkexList from '../Components/WorkexList';

const Workex = () => {
    return (
        <React.Fragment>
            <WorkexList />
        </React.Fragment>
    )
}

export default Workex;
